(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["masonry"] && !Shopify.designMode) return;
  try {
    
  const initMasonry = () => {
    setTimeout(() => {
      const instance = new Masonry('[data-masonry-grid]', {
        itemSelector: '[data-masonry-item]',
        horizontalOrder: true,
        percentPosition: true
      });
    }, 500);
  }

  window.addEventListener('shopify:section:load', () => {
    initMasonry();
  });

  document.addEventListener('DOMContentLoaded', () => {
    initMasonry();
  });

  } catch(e) { console.error(e); }
})();
})();
